__webpack_require__.p = "/receivingpo/";